<!-- eslint-disable vue/no-deprecated-v-bind-sync -->
<template>
    <div class="calendar__events" v-loading="loadingPreviousEvents">
        <div
            class="calendar-scroller"
            style="max-height: calc(100vh - 234px); overflow: auto"
        >
            <calendar
                ref="calendar"
                @click-date="onDateClick"
                :form="form"
                :events="events"
                v-if="form.year"
                :year="form.year"
                :month="form.month"
            />
        </div>
        <el-dialog
            :visible.sync="editDateDialogVisible"
            width="1000px"
            :close-on-click-modal="false"
            class="dialog-edit-date"
        >
            <div slot="title">
                {{
                    editingDate
                        ? "Events for " +
                          editingDate.format("MMMM Do, YYYY") +
                          ` (${editingEvents.length})`
                        : ""
                }}
                <transition name="el-fade-in">
                    <span
                        class="ml-10 mt-8 success-text text-small"
                        v-show="showAutoSaveMessage"
                    >
                        <i class="mdi mdi-check-circle" /> Auto-saved
                    </span>
                </transition>
                <transition name="el-fade-in">
                    <span
                        class="ml-10 mt-8 warning-text text-small"
                        v-show="showAutoSaveValidationMessage"
                    >
                        <i class="mdi mdi-alert-circle" /> Can't auto-save,
                        please check validation
                    </span>
                </transition>
                <transition name="el-fade-in">
                    <span
                        class="ml-10 mt-8 error-text text-small"
                        v-show="showAutoSaveError"
                    >
                        <i class="mdi mdi-alert-circle" /> Auto-save failed
                    </span>
                </transition>
                <span
                    class="ml-10 mt-8 warning-text text-small"
                    v-show="
                        !showAutoSaveMessage &&
                        !showAutoSaveValidationMessage &&
                        hasChanges
                    "
                >
                    You have unsaved changes.
                </span>
            </div>
            <div>
                <el-form class="form-edit-events">
                    <h3
                        class="text-center mt-0 mb-0 text-uppercase"
                        v-if="editingDate"
                    >
                        {{ editingDate.format("dddd") }}
                    </h3>
                    <el-table
                        :data="availableEditingEvents"
                        default-expand-all
                        row-key="_uuid"
                        stripe
                    >
                        <el-table-column type="expand">
                            <template v-slot="scope">
                                <el-form @submit.prevent>
                                    <el-form-item
                                        label-width="0"
                                        class="d-inline-block el-checkbox-group--minimal-margin"
                                    >
                                        <el-checkbox
                                            @change="
                                                (e) =>
                                                    onChangeAllDay(scope.row, e)
                                            "
                                            v-model="scope.row.is_all_day"
                                            >All Day
                                        </el-checkbox>
                                        <el-checkbox v-model="scope.row.is_bold"
                                            >Bold</el-checkbox
                                        >
                                        <el-checkbox
                                            v-model="scope.row.is_repeat"
                                            @change="
                                                onChangeIsRepeat(scope.row)
                                            "
                                        >
                                            Repeat
                                        </el-checkbox>
                                    </el-form-item>
                                    <el-form-item
                                        label-width="0"
                                        v-if="scope.row.is_repeat"
                                        :class="{
                                            'is-error': veeErrors.has(
                                                'repeat_interval-' +
                                                    scope.row._uuid
                                            )
                                        }"
                                        style="width: 160px"
                                        class="repeat-options d-inline-block"
                                    >
                                        <el-select
                                            v-model="scope.row.repeat_interval"
                                            placeholder="Select Repeat Interval"
                                            :name="
                                                'repeat_interval-' +
                                                scope.row._uuid
                                            "
                                            v-validate="
                                                scope.row.is_repeat
                                                    ? 'required'
                                                    : null
                                            "
                                            data-vv-validate-on="change"
                                            @change="
                                                onRepeatIntervalChange(
                                                    scope.row
                                                )
                                            "
                                        >
                                            <el-option
                                                v-for="item in availableRepeatIntervals"
                                                :key="item"
                                                :label="
                                                    $options.filters.capitalize(
                                                        item
                                                    )
                                                "
                                                :value="item"
                                            >
                                            </el-option>
                                        </el-select>
                                        <div
                                            class="el-form-item__error"
                                            v-if="
                                                veeErrors.has(
                                                    'repeat_interval-' +
                                                        scope.row._uuid
                                                )
                                            "
                                        >
                                            Repeat interval is required.
                                        </div>
                                    </el-form-item>
                                    <el-form-item
                                        label="Repeat on:"
                                        class="d-inline-block el-checkbox-group--minimal-margin"
                                        style="width: 470px"
                                        :class="{
                                            'is-error':
                                                !hasSelectedDayForWeeklyEvent(
                                                    scope.row
                                                )
                                        }"
                                        v-if="
                                            scope.row.repeat_interval ===
                                                RepeatIntervals.WEEKLY ||
                                            scope.row.repeat_interval ===
                                                RepeatIntervals.BIWEEKLY
                                        "
                                    >
                                        <el-checkbox
                                            :name="
                                                'weekly-sunday-' +
                                                scope.row._uuid
                                            "
                                            v-model="scope.row.weekly_sunday"
                                            >Su
                                        </el-checkbox>
                                        <el-checkbox
                                            :name="
                                                'weekly-monday-' +
                                                scope.row._uuid
                                            "
                                            v-model="scope.row.weekly_monday"
                                            >M
                                        </el-checkbox>
                                        <el-checkbox
                                            :name="
                                                'weekly-tuesday-' +
                                                scope.row._uuid
                                            "
                                            v-model="scope.row.weekly_tuesday"
                                            >Tu
                                        </el-checkbox>
                                        <el-checkbox
                                            :name="
                                                'weekly-wednesday-' +
                                                scope.row._uuid
                                            "
                                            v-model="scope.row.weekly_wednesday"
                                            >W
                                        </el-checkbox>
                                        <el-checkbox
                                            :name="
                                                'weekly-thursday-' +
                                                scope.row._uuid
                                            "
                                            v-model="scope.row.weekly_thursday"
                                            >Th
                                        </el-checkbox>
                                        <el-checkbox
                                            :name="
                                                'weekly-friday-' +
                                                scope.row._uuid
                                            "
                                            v-model="scope.row.weekly_friday"
                                            >F
                                        </el-checkbox>
                                        <el-checkbox
                                            :name="
                                                'weekly-saturday-' +
                                                scope.row._uuid
                                            "
                                            v-model="scope.row.weekly_saturday"
                                            >Sa
                                        </el-checkbox>
                                        <input
                                            type="hidden"
                                            :name="
                                                'weekly_day-' + scope.row._uuid
                                            "
                                            v-validate="
                                                hasSelectedDayForWeeklyEvent(
                                                    scope.row
                                                )
                                                    ? ''
                                                    : 'required'
                                            "
                                        />
                                        <div
                                            class="el-form-item__error"
                                            v-if="
                                                veeErrors.has(
                                                    'weekly_day-' +
                                                        scope.row._uuid
                                                )
                                            "
                                        >
                                            Please select day(s).
                                        </div>
                                    </el-form-item>
                                    <template
                                        v-if="
                                            scope.row.repeat_interval ===
                                            RepeatIntervals.MONTHLY
                                        "
                                    >
                                        <el-form-item
                                            label-width="100px"
                                            class="d-inline-block"
                                            label="Repeat on:"
                                            style="width: 240px"
                                            :class="{
                                                'is-error': veeErrors.has(
                                                    'monthly_week-' +
                                                        scope.row._uuid
                                                )
                                            }"
                                        >
                                            <el-select
                                                style="width: 100%"
                                                v-model="scope.row.monthly_week"
                                                v-validate="'required'"
                                                :name="
                                                    'monthly_week-' +
                                                    scope.row._uuid
                                                "
                                                placeholder="Select"
                                            >
                                                <el-option
                                                    v-for="(
                                                        name, i
                                                    ) in MonthlyWeekStrings"
                                                    :key="i"
                                                    :label="
                                                        $options.filters.lowercase(
                                                            name
                                                        )
                                                    "
                                                    :value="
                                                        $options.filters.lowercase(
                                                            name
                                                        )
                                                    "
                                                />
                                            </el-select>
                                            <div
                                                class="el-form-item__error"
                                                v-if="
                                                    veeErrors.has(
                                                        'monthly_week-' +
                                                            scope.row._uuid
                                                    )
                                                "
                                            >
                                                Please select week.
                                            </div>
                                        </el-form-item>
                                        <el-form-item
                                            class="d-inline-block"
                                            style="width: 140px"
                                            :class="{
                                                'is-error': veeErrors.has(
                                                    'monthly_day-' +
                                                        scope.row._uuid
                                                )
                                            }"
                                        >
                                            <el-select
                                                style="width: 100%"
                                                v-model="scope.row.monthly_day"
                                                v-validate="'required'"
                                                :name="
                                                    'monthly_day-' +
                                                    scope.row._uuid
                                                "
                                                placeholder="Select Day"
                                            >
                                                <el-option
                                                    :key="day"
                                                    v-for="(
                                                        day, key
                                                    ) in WeekDays"
                                                    :label="
                                                        $options.filters.capitalize(
                                                            $options.filters.lowercase(
                                                                key
                                                            )
                                                        )
                                                    "
                                                    :value="day"
                                                />
                                            </el-select>
                                            <div
                                                class="el-form-item__error"
                                                v-if="
                                                    veeErrors.has(
                                                        'monthly_day-' +
                                                            scope.row._uuid
                                                    )
                                                "
                                            >
                                                Please select day.
                                            </div>
                                        </el-form-item>
                                    </template>
                                </el-form>
                            </template>
                        </el-table-column>
                        <el-table-column label="Description">
                            <template v-slot="scope">
                                <el-form-item
                                    :class="{
                                        'is-error': veeErrors.has(
                                            'description-' + scope.row._uuid
                                        )
                                    }"
                                >
                                    <el-input
                                        @click.native="
                                            onClickDescription(
                                                $event,
                                                scope.row
                                            )
                                        "
                                        @focus.native="
                                            onFocusDescription(
                                                $event,
                                                scope.row
                                            )
                                        "
                                        @keypress.enter.native="
                                            onEnterEventDescription(
                                                $event,
                                                scope.row
                                            )
                                        "
                                        @keyup.native="
                                            onKeyUpDescription(
                                                $event,
                                                scope.row
                                            )
                                        "
                                        @input="
                                            clearValidationError(
                                                'description-' + scope.row._uuid
                                            )
                                        "
                                        style="width: 100%"
                                        type="text"
                                        v-validate="'required'"
                                        data-vv-validate-on="blur"
                                        :name="'description-' + scope.row._uuid"
                                        v-model="scope.row.description"
                                    />
                                    <div
                                        class="el-form-item__error"
                                        v-if="
                                            veeErrors.has(
                                                'description-' + scope.row._uuid
                                            )
                                        "
                                    >
                                        Description is required.
                                    </div>
                                </el-form-item>
                            </template>
                        </el-table-column>
                        <el-table-column label="Time" width="160px">
                            <template v-slot="scope">
                                <el-form-item
                                    :class="{
                                        'is-error':
                                            veeErrors.has(
                                                'time-' + scope.row._uuid
                                            ) &&
                                            checkTimeValueBeforeThrowsError(
                                                scope.row
                                            )
                                    }"
                                >
                                    <el-input
                                        :disabled="scope.row.is_all_day"
                                        class="timepicker"
                                        :class="'timepicker-' + scope.row._uuid"
                                        :name="'time-' + scope.row._uuid"
                                        :data-event-uuid="scope.row._uuid"
                                        style="width: 100%"
                                        type="text"
                                        v-validate="
                                            !scope.row.is_all_day
                                                ? 'required'
                                                : null
                                        "
                                        data-vv-validate-on="blur|input"
                                        @input="onTimeInput(scope.row)"
                                        @blur="onTimeBlur(scope.row)"
                                        v-model="scope.row.time"
                                    />
                                    <div
                                        class="el-form-item__error"
                                        v-if="
                                            veeErrors.has(
                                                'time-' + scope.row._uuid
                                            ) &&
                                            checkTimeValueBeforeThrowsError(
                                                scope.row
                                            )
                                        "
                                    >
                                        Time is required.
                                    </div>
                                </el-form-item>
                            </template>
                        </el-table-column>
                        <el-table-column label="Color" width="70px">
                            <template v-slot="scope">
                                <el-form-item class="mb-20 pt-15">
                                    <color-picker
                                        v-model="scope.row.color"
                                        :predefine="predefinedColors"
                                    >
                                    </color-picker>
                                </el-form-item>
                            </template>
                        </el-table-column>
                        <el-table-column width="120px">
                            <template v-slot="scope">
                                <el-form-item>
                                    <el-button
                                        size="small"
                                        type="danger"
                                        @click="removeEvent(scope.row)"
                                        ><i class="mdi mdi-delete" />Delete
                                    </el-button>
                                </el-form-item>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-form>
                <el-button
                    @click="addNewEvent()"
                    class="mt-10"
                    type="primary"
                    icon="mdi mdi-plus"
                    round
                    >New Event
                </el-button>
            </div>
            <div slot="footer" class="dialog-footer">
                <span
                    class="text-error mr-10"
                    v-if="veeErrors.any() && shouldShowValidationErrors"
                >
                    <i class="mdi mdi-alert-circle" />
                    Please fill in the missing information highlighted in red.
                </span>
                <el-button @click="editDateDialogVisible = false"
                    >Cancel</el-button
                >
                <el-button
                    :disabled="form.busy || autoSaveForm.busy"
                    @click="saveDate()"
                    icon="mdi mdi-content-save"
                    :loading="savingDate"
                    type="primary"
                    >Save
                </el-button>
            </div>
        </el-dialog>
        <el-dialog
            title="Do you want to delete this event only or all future events?"
            :visible.sync="deleteDialogVisible"
            width="950px"
        >
            <el-radio-group v-model="deleteForm.occurrence">
                <div style="margin-top: 20px; padding: 10px">
                    <el-radio :label="DeletedEventOccurrence.FUTURE_EVENTS"
                        ><span style="font-size: 22px"
                            >I want to delete
                            <span style="font-weight: bold"
                                >THIS EVENT INSTANCE</span
                            >
                            and
                            <span style="font-weight: bold"
                                >ALL FUTURE INSTANCES</span
                            >
                            of this event.</span
                        >
                    </el-radio>
                </div>
                <div style="margin-top: 20px; padding: 10px; font-size: 16px">
                    <el-radio :label="DeletedEventOccurrence.SINGLE"
                        ><span style="font-size: 22px"
                            >I want to delete
                            <span style="font-weight: bold"
                                >THIS EVENT INSTANCE</span
                            >
                            only.</span
                        ></el-radio
                    >
                </div>
            </el-radio-group>
            <div slot="footer">
                <div class="float-right">
                    <el-button
                        type="danger"
                        icon="mdi mdi-delete"
                        @click="confirmDelete"
                        >Delete</el-button
                    >
                </div>
                <div class="clearfix"></div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
//TODO: if delete weekly event 4 times in a month, then ask to delete event
import * as DeletedEventOccurrence from "@/constants/deleted-event-occurrence";
import * as MonthlyWeeks from "@/constants/monthly-weeks";
import * as RepeatIntervals from "@/constants/repeat-intervals";
import * as WeekDays from "@/constants/week-days";
import event_availability_mixin from "@/mixins/events/availability";
import CalendarUtils from "@/utils/calendar";
import $ from "jquery";
import _ from "lodash";
import moment from "moment";
import uniqid from "uniqid";
import Vue from "vue";
import { mapState } from "vuex";
import Calendar from "./Calendar";

export default {
    mixins: [event_availability_mixin],
    components: {
        Calendar
    },
    props: {
        form: {
            type: Object,
            required: true
        },
        calendar: {
            type: Object
        }
    },
    data() {
        return {
            RepeatIntervals,
            WeekDays,
            MonthlyWeeks,
            DeletedEventOccurrence,
            events: [],
            editDateDialogVisible: false,
            deleteDialogVisible: false,
            editingDate: null, //editing date
            editingEvents: [],
            eventElements: [],
            header_visible: true,
            deletingEvent: null,
            eventsToDelete: [],
            loadingPreviousEvents: false,
            deleteForm: new window.Form({
                occurrence: DeletedEventOccurrence.FUTURE_EVENTS
            }),
            autoSaveForm: new window.Form({
                font: null,
                font_size: null,
                date: null,
                events: [],
                dates: []
            }),
            descriptionInputCursor: {
                start: 0,
                end: 0
            },
            savingDate: false,
            autoSaving: false,
            autoSaveInterval: null,
            showAutoSaveValidationMessage: false,
            showAutoSaveError: false,
            oldEditingEvents: null,
            showAutoSaveMessage: false,
            canEdit: true,
            attemptedSave: false
        };
    },
    mounted() {
        if (!this.calendar) {
            this.fetchPreviousEvents();
        }
    },
    created() {
        window.Bus.$once("error:order_pending_for_current_month", () => {
            this.stopAutoSave();
            this.canEdit = false;
        });
    },
    computed: {
        ...mapState({
            MonthlyWeekStrings: (state) => state.enums.monthly_week_strings
        }),
        current_community() {
            return this.$parent.current_community;
        },
        predefinedColors() {
            return this.$store.state.config.settings.font.colors;
        },
        availableRepeatIntervals() {
            return _.filter(RepeatIntervals, (item) => {
                return item !== RepeatIntervals.NO_REPEAT;
            });
        },
        currentMonth() {
            return this.$parent.currentMonth;
        },
        hasMaxedOutDate() {
            if (!this.$refs.calendar) {
                return false;
            }
            return this.$refs.calendar.maxedOutDates.length > 0;
        },
        availableEditingEvents() {
            if (!this.editingDate) {
                return [];
            }
            return this.filterDeletedEvents(
                this.editingEvents,
                this.editingDate
            );
        },
        calendarCalculator() {
            return this.$parent.calendarCalculator;
        },
        hasChanges() {
            return JSON.stringify(this.editingEvents) !== this.oldEditingEvents;
        },
        shouldShowValidationErrors() {
            // Show validation errors if user has attempted to save or auto-save
            return (
                this.attemptedSave ||
                this.autoSaving ||
                this.showAutoSaveValidationMessage
            );
        }
    },
    watch: {
        editDateDialogVisible(val) {
            if (val) {
                this.initAutoSave();
            } else {
                this.stopAutoSave();
                this.attemptedSave = false; // Reset when dialog closes

                // Add a small delay to ensure the dialog is fully closed
                // before recalculating the calendar layout
                setTimeout(() => {
                    this.refreshCalendar();
                }, 150);
            }
        },
        "form.font": {
            handler() {
                Vue.nextTick(() => {
                    this.checkDateLines();
                    CalendarUtils.clearDescriptionLinesCache();
                });
            }
        },
        "form.font_size": {
            handler() {
                Vue.nextTick(() => {
                    this.checkDateLines();
                    CalendarUtils.clearDescriptionLinesCache();
                });
            }
        },
        // Log veeErrors when the error message would be shown
        "veeErrors.items": {
            handler(items) {
                if (
                    this.veeErrors &&
                    typeof this.veeErrors.any === "function" &&
                    this.veeErrors.any()
                ) {
                    // Log the actual error items and all error messages
                    console.log(
                        "[Events.vue] veeErrors.any() is true. Error items:",
                        items
                    );
                    if (typeof this.veeErrors.all === "function") {
                        console.log(
                            "[Events.vue] veeErrors.all():",
                            this.veeErrors.all()
                        );
                    }
                }
            },
            deep: true
        }
    },
    beforeDestroy() {
        // Clean up any running intervals
        this.stopAutoSave();

        // Clean up any other resources
        if (this.someOtherInterval) {
            clearInterval(this.someOtherInterval);
        }
    },
    beforeRouteLeave(to, from, next) {
        // Clean up before navigating away
        this.stopAutoSave();
        next();
    },
    methods: {
        checkDateLines() {
            this.updateEventDescriptionLines();
            if (this.$refs.calendar) {
                Vue.nextTick(() => {
                    this.$refs.calendar.checkDateLines();
                });
            }
        },
        //TODO: generate calendar events and save server-side
        fetchPreviousEvents() {
            this.loadingPreviousEvents = true;
            window.axios
                .get(`/web-api/calendar/previous-events?`, {
                    params: {
                        include: "deleted_events",
                        community_location_id: this.form.community_location_id
                    }
                })
                .then((response) => {
                    response.data.data.forEach((event) => {
                        if (!event.event_parent) {
                            let new_event = _.cloneDeep(event);
                            event.event_parent = new_event.id;
                            event.parent = new_event;
                        }
                        let event_date = moment(event.event_date);
                        event.event_date = event_date
                            .add(1, "month")
                            .format("YYYY-MM-DD");
                        event.id = null;
                    });
                    this.initEvents(response.data.data);
                    if (response.data.data.length) {
                        this.$message({
                            message:
                                "Events pre-filled from previous month calendar.",
                            type: "success"
                        });
                    }
                })
                .finally(() => (this.loadingPreviousEvents = false));
        },
        /**
         * Initializes the calendar with the given events.
         * @param {Object} calendar - The calendar object containing the events.
         * @param {boolean} [update_ids=false] - Whether to only update the ids of events or to initialize all events.
         */
        initCalendar(calendar, update_ids = false) {
            if (update_ids) {
                // only update the ids of events
                this.updateEventIds(calendar.events.data);
            } else {
                this.events = [];
                this.initEvents(calendar.events.data);
            }
        },
        /**
         * Updates the ids of events in the calendar.
         * @param {Object[]} events - The events to update.
         * @throws {Error} If the event index is not found.
         */
        updateEventIds(events) {
            events.forEach((event, i) => {
                if (!this.events[i]) {
                    throw new Error("Event index not found: " + i);
                }
                if (event.description !== this.events[i].description) {
                    console.warn(
                        "description not the same",
                        event.id,
                        event.description,
                        this.events[i].id,
                        this.events[i].description
                    );
                }
                this.events[i].id = event.id;
            });
        },
        /**
         * Initializes the events array with the given events.
         * @param {Object[]} events - The events to initialize.
         */
        initEvents(events) {
            events.forEach((event) => {
                event = _.cloneDeep(event);
                event.deleted_events = _.get(event, "deleted_events.data", []);
                event.date = moment(event.event_date);
                if (!event.is_all_day) {
                    event.time =
                        event.date.format("YYYY-MM-DD") +
                        " " +
                        event.event_time;
                }
                event.is_repeat =
                    event.repeat_interval !== RepeatIntervals.NO_REPEAT;
                event._uuid = uniqid();
                let formatted_event = this.formatEvent(event);
                this.events.push(formatted_event);
            });
            // TODO: check what this is for. no original_event property exists anywhere in the code
            // this.events = _.reject(this.events, (item) => {
            //     return !!item.original_event;
            // });
            CalendarUtils.clearDescriptionLinesCache();
            this.checkDateLines();
        },
        initOldEditingEvents() {
            this.oldEditingEvents = JSON.stringify(this.editingEvents);
        },
        onDateClick(date, events) {
            this.editDate(date, events);
        },
        editDate(date, events) {
            this.editingDate = date;
            this.eventsToDelete = [];
            this.editingEvents = events.map((item) => _.cloneDeep(item));
            this.editingEvents.forEach((item) => {
                item.time = item.time ? item.time.format("hh:mm A") : null;
            });
            this.editDateDialogVisible = true;
            this.initTimePicker().then(() => {
                this.initOldEditingEvents();
            });
        },
        initTimePicker(event = null) {
            let self = this;
            return new Promise((resolve, reject) => {
                Vue.nextTick(() => {
                    $(
                        `.timepicker${
                            !event ? "" : ".timepicker-" + event._uuid
                        } input`
                    ).timepicker({
                        timeFormat: "hh:mm p",
                        interval: 15,
                        minTime: "01",
                        maxTime: "11:45 pm",
                        startTime: "05:00",
                        dynamic: false,
                        dropdown: true,
                        scrollbar: false,
                        change: function (time) {
                            let element = $(this);
                            let uuid = element.data("event-uuid");
                            let event = self.editingEvents.find((item) => {
                                return item._uuid === uuid;
                            });
                            const fieldName = "time-" + uuid;
                            const before = {
                                fieldName,
                                eventTime: event.time,
                                veeHas: self.veeErrors.has(fieldName),
                                veeAll: self.veeErrors.all(),
                                veeAny: self.veeErrors.any()
                            };
                            event.time = !time
                                ? null
                                : moment(time).format("hh:mm A");
                            element.val(event.time);
                            element.trigger("input");
                            Vue.nextTick(() => {
                                self.$validator
                                    .validate(fieldName)
                                    .then((result) => {
                                        const after = {
                                            fieldName,
                                            eventTime: event.time,
                                            veeHas: self.veeErrors.has(
                                                fieldName
                                            ),
                                            veeAll: self.veeErrors.all(),
                                            veeAny: self.veeErrors.any(),
                                            validationResult: result
                                        };
                                    });
                            });
                        }
                    });
                    resolve();
                });
            });
        },
        addNewEvent() {
            let event;
            this.editingEvents.push(
                (event = {
                    _uuid: uniqid(),
                    id: null,
                    title: "",
                    description: "",
                    start: null,
                    date: this.editingDate.clone(),
                    time: null,
                    is_all_day: false,
                    is_bold: false,
                    is_repeat: false,
                    color: "#000",
                    repeat_interval: RepeatIntervals.NO_REPEAT,
                    weekly_sunday: false,
                    weekly_monday: false,
                    weekly_tuesday: false,
                    weekly_wednesday: false,
                    weekly_thursday: false,
                    weekly_friday: false,
                    weekly_saturday: false,
                    monthly_week: null,
                    monthly_day: null,
                    dow: [],
                    deleted_events: []
                })
            );
            this.initTimePicker(event);
        },
        removeEvent(event) {
            if (event.repeat_interval === RepeatIntervals.NO_REPEAT) {
                this.$confirm(
                    "Are you sure you want to remove event?",
                    "Confirmation",
                    {
                        confirmButtonText: "Yes",
                        confirmButtonClass: "el-button--danger",
                        cancelButtonText: "Cancel",
                        type: "warning"
                    }
                )
                    .then(() => {
                        this.eventsToDelete.push(event);
                        window.Utils.arrayDelete(this.editingEvents, event);
                    })
                    .catch(() => {
                        // user cancelled the confirmation
                    });
            } else {
                this.deleteDialogVisible = true;
                this.deletingEvent = event;
            }
        },
        confirmDelete() {
            this.deletingEvent.deleted_events.push({
                date_from: this.editingDate.format("YYYY-MM-DD"),
                occurrence: this.deleteForm.occurrence
            });
            this.deleteDialogVisible = false;
        },
        onChangeIsRepeat(event) {
            event.repeat_interval = event.is_repeat
                ? null
                : RepeatIntervals.NO_REPEAT;
        },
        hasSelectedDayForWeeklyEvent(event) {
            let has_selected = false;
            _.forEach(WeekDays, (weekday_index, key) => {
                if (event["weekly_" + key.toLowerCase()]) {
                    has_selected = true;
                    return false;
                }
            });
            return has_selected;
        },
        onChangeAllDay(event, val) {
            if (val) {
                event.time = null;
            }
        },
        //TODO: save to local browser
        initAutoSave() {
            this.stopAutoSave();
            // Skip autosave setup for staff users
            if (this.$parent && this.$parent.isStaffUser) {
                console.log(
                    "Autosave disabled for staff user in Events component"
                );
                return;
            }

            if (!this.canEdit) {
                return;
            }
            this.autoSaveInterval = setInterval(() => {
                if (this.form.busy) {
                    return;
                }
                if (!this.hasChanges) {
                    return;
                }

                // Check if user is actively typing - add this section
                if (
                    this.$parent &&
                    this.$parent.lastTypingTimestamp &&
                    Date.now() - this.$parent.lastTypingTimestamp < 3000
                ) {
                    console.log(
                        "User is actively typing, postponing auto-save"
                    );
                    return;
                }

                let promise = this.autoSave();
                if (promise) {
                    promise.catch((e) => {
                        if (e === "validation errors") {
                            return;
                        }
                        console.log(e);
                        throw e;
                    });
                }
            }, 60 * 1000);
        },
        stopAutoSave() {
            if (this.autoSaveInterval) {
                clearInterval(this.autoSaveInterval);
                this.autoSaveInterval = null; // Set to null to prevent double-clearing
            }
        },
        //method to save event form data in json format to local storage

        autoSave() {
            if (this.autoSaveForm.busy || this.autoSaving) {
                // still saving
                return null;
            }
            return new Promise((resolve, reject) => {
                this.showAutoSaveValidationMessage = false;
                // Only validate if the user has actually interacted with the form
                this.validateBeforeSubmit().then((valid) => {
                    if (!valid) {
                        this.showAutoSaveValidationMessage = true;
                        reject("validation errors");
                        return;
                    }
                    this.autoSaving = true;
                    let save = () => {
                        this.autoSaveForm.date =
                            this.editingDate.format("YYYY-MM-DD");
                        this.autoSaveForm.font = this.form.font;
                        this.autoSaveForm.font_size = this.form.font_size;
                        this.autoSaveForm.events = [];
                        this.editingEvents.forEach((item) => {
                            let existing = this.events.find((item_1) => {
                                return (
                                    (item_1.id && item_1.id === item.id) ||
                                    item_1._uuid === item._uuid
                                );
                            });
                            if (existing) {
                                _.extend(existing, _.omit(item, ["id"]));
                                this.autoSaveForm.events.push(
                                    this.formatEvent(existing)
                                );
                            } else {
                                let event = this.formatEvent(_.cloneDeep(item));
                                this.events.push(event);
                                this.autoSaveForm.events.push(event);
                            }
                        });
                        this.eventsToDelete.forEach((event) => {
                            let existing = this.autoSaveForm.events.filter(
                                (item) =>
                                    item._uuid === event._uuid ||
                                    (event.id && event.id === item.id)
                            );
                            if (existing.length) {
                                existing.forEach((item) => {
                                    window.Utils.arrayDelete(
                                        this.autoSaveForm.events,
                                        item
                                    );
                                });
                            }
                        });
                        if (this.$refs.calendar) {
                            // weird issue happening where the $refs.calendar is undefined
                            this.autoSaveForm.dates = [
                                {
                                    date: this.editingDate.format("YYYY-MM-DD"),
                                    first_line_overlaps_date:
                                        this.calendarCalculator.firstLineOverlapsDateNumber(
                                            this.$refs.calendar.getEventsForDate(
                                                this.editingDate
                                            )
                                        )
                                }
                            ];
                        }
                        //console.log("auto saving", this.autoSaveForm);
                        window.App.put(
                            `/web-api/calendar/${this.calendar.id}/event`,
                            this.autoSaveForm,
                            (data) => {
                                data.events = this.autoSaveForm.events.map(
                                    (item) => this.getEventForSaving(item)
                                );
                            }
                        )
                            .then((response) => {
                                //console.log("auto saved", response);
                                this.showAutoSaveMessage = true;
                                this.showAutoSaveError = false;
                                setTimeout(() => {
                                    this.showAutoSaveMessage = false;
                                }, 5000);
                                _.forEach(response.data.data, (e, i) => {
                                    this.editingEvents[i].id = e.id;
                                    this.autoSaveForm.events[i].id = e.id;
                                });
                                this.eventsToDelete.forEach((event) => {
                                    // remove only events that are not recurring
                                    if (
                                        event.repeat_interval !==
                                        RepeatIntervals.NO_REPEAT
                                    ) {
                                        return;
                                    }
                                    // find existing event, and remove it from events array
                                    let existing = this.events.filter(
                                        (item) =>
                                            item._uuid === event._uuid ||
                                            (event.id && event.id === item.id)
                                    );
                                    if (existing) {
                                        existing.forEach((item) => {
                                            window.Utils.arrayDelete(
                                                this.events,
                                                item
                                            );
                                        });
                                    }
                                });
                                this.initOldEditingEvents();
                                this.$emit("auto-saved");

                                // After updates are complete, refresh the calendar
                                setTimeout(() => {
                                    this.refreshCalendar();
                                }, 150);

                                resolve(response);
                            })
                            .catch((error) => {
                                console.log(error);
                                this.showAutoSaveError = true;
                                setTimeout(() => {
                                    this.showAutoSaveError = false;
                                }, 5000);
                                reject(error);
                            })
                            .finally(() => {
                                this.autoSaving = false;
                            });
                    };
                    if (this.calendar) {
                        save();
                    } else {
                        this.$parent
                            .saveEvents()
                            .then(() => {
                                save();
                            })
                            .catch(() => {
                                this.autoSaving = false;
                                this.showAutoSaveError = true;
                                setTimeout(() => {
                                    this.showAutoSaveError = false;
                                }, 5000);
                            });
                    }
                });
            });
        },
        saveDate() {
            this.autoSaving = false;
            this.savingDate = true;
            this.attemptedSave = true;
            // Use the new validation method
            this.validateBeforeSubmit().then((isValid) => {
                if (!isValid) {
                    this.savingDate = false;
                    // Keep attemptedSave true so error message stays visible
                    return;
                }

                let promise = this.autoSave();
                if (promise) {
                    promise
                        .then(() => {
                            this.editDateDialogVisible = false;
                            this.savingDate = false;
                            this.attemptedSave = false; // Reset on success
                            setTimeout(() => {
                                this.refreshCalendar();
                                this.$emit("date-saved");
                            }, 150);
                        })
                        .catch(() => {
                            this.savingDate = false;
                            // Keep attemptedSave true
                        });
                } else {
                    this.editDateDialogVisible = false;
                    this.savingDate = false;
                    this.attemptedSave = false;
                }
            });
        },
        formatEvent(event) {
            let datetime = moment(
                event.time,
                "YYYY-MM-DD HH:mm",
                true
            ).isValid()
                ? event.is_all_day
                    ? ""
                    : " " + event.time
                : event.date.format("YYYY-MM-DD") +
                  (event.is_all_day ? "" : " " + event.time);
            _.extend(event, {
                title: event.description,
                start: moment(datetime, "YYYY-MM-DD hh:mm A").format(
                    "YYYY-MM-DD HH:mm:ss"
                ),
                dow: []
            });
            event.time = event.is_all_day ? null : moment(event.start);
            if (
                event.repeat_interval !== RepeatIntervals.WEEKLY &&
                event.repeat_interval !== RepeatIntervals.BIWEEKLY
            ) {
                //reset weekly settings
                _.forEach(WeekDays, (weekday_index, key) => {
                    event["weekly_" + key.toLowerCase()] = false;
                });
            }
            switch (event.repeat_interval) {
                case RepeatIntervals.EVERY_WEEKDAY:
                    event.start = event.time
                        ? moment(event.time).format("HH:mm:ss")
                        : moment().format("HH:mm:ss");
                    event.dow = [1, 2, 3, 4, 5];
                    break;
                case RepeatIntervals.DAILY:
                    event.start = event.time
                        ? moment(event.time).format("HH:mm:ss")
                        : moment().format("HH:mm:ss");
                    event.dow = [];
                    _.forEach(WeekDays, (weekday_index) => {
                        event.dow.push(weekday_index);
                    });
                    break;
                case RepeatIntervals.WEEKLY:
                    event.start = event.time
                        ? moment(event.time).format("HH:mm:ss")
                        : moment().format("HH:mm:ss");
                    event.dow = [];
                    _.forEach(WeekDays, (weekday_index, key) => {
                        if (event["weekly_" + key.toLowerCase()]) {
                            event.dow.push(weekday_index);
                        }
                    });
                    break;
                case RepeatIntervals.BIWEEKLY:
                    event.start = event.time
                        ? moment(event.time).format("HH:mm:ss")
                        : moment().format("HH:mm:ss");
                    event.dow = [];
                    _.forEach(WeekDays, (weekday_index, key) => {
                        if (event["weekly_" + key.toLowerCase()]) {
                            event.dow.push(weekday_index);
                        }
                    });
                    break;
                case RepeatIntervals.MONTHLY:
                    let start = moment([
                        this.form.year,
                        this.form.month - 1
                    ]).startOf("month");
                    let current_month_start = start.clone().startOf("day");
                    let current_month_end = start
                        .clone()
                        .endOf("month")
                        .startOf("day");

                    let occurrence = 0;
                    let monthly_week = _.find(MonthlyWeeks, (value, key) => {
                        return key.toLowerCase() === event.monthly_week;
                    });
                    let monthly_day = _.find(WeekDays, (value, key) => {
                        return value === event.monthly_day;
                    });

                    //find the derived event date
                    while (
                        current_month_start.isSameOrBefore(current_month_end)
                    ) {
                        if (current_month_start.day() === monthly_day) {
                            occurrence++;
                        }
                        if (occurrence === monthly_week) {
                            break;
                        }
                        current_month_start.add(1, "day");
                    }

                    let new_event_start = current_month_start.clone();

                    if (!event.is_all_day) {
                        new_event_start
                            .hour(moment(event.time).hour())
                            .minute(moment(event.time).minute());
                    }

                    event["start"] = new_event_start.format(
                        "YYYY-MM-DD HH:mm:ss"
                    );
                    break;
                default:
                    break;
            }
            return event;
        },
        getEventForSaving(item) {
            let formatted = _.pick(item, [
                "id",
                "description",
                "color",
                "is_all_day",
                "is_bold",
                "repeat_interval",
                "weekly_sunday",
                "weekly_monday",
                "weekly_tuesday",
                "weekly_wednesday",
                "weekly_thursday",
                "weekly_friday",
                "weekly_saturday",
                "monthly_week",
                "monthly_day",
                "deleted_events",
                "event_parent"
            ]);
            formatted.event_date = moment(item.date).format("YYYY-MM-DD");
            if (formatted.color === "#000") {
                formatted.color = "#000000";
            }
            if (formatted.is_all_day) {
                formatted.time = null;
            }
            if (!formatted.is_all_day && item.time) {
                formatted.event_time = moment(item.time).format("HH:mm");
            }
            formatted.description_lines =
                CalendarUtils.getEventDescriptionLines(
                    item,
                    this.form.font,
                    this.form.font_size
                );
            formatted.description_lines_as_first =
                CalendarUtils.getEventDescriptionLines(
                    item,
                    this.form.font,
                    this.form.font_size,
                    true
                );
            return formatted;
        },
        updateEventDescriptionLines() {
            this.events.forEach((event) => {
                event.description_lines =
                    CalendarUtils.getEventDescriptionLines(
                        event,
                        this.form.font,
                        this.form.font_size
                    );
            });
        },
        getCleanEvents() {
            return (
                this.events
                    //TODO: triple check what this is for. no original_event property exists anywhere in the code
                    // .filter((event) => {
                    //     return (
                    //         !event.original_event ||
                    //         event.repeat_interval === RepeatIntervals.MONTHLY
                    //     );
                    // })
                    .map((item) => {
                        return this.getEventForSaving(item);
                    })
            );
        },
        /**
         * Get the date infos to be sent to backend.
         *
         * @returns {Array}
         */
        getDates() {
            if (!this.$refs.calendar) {
                return [];
            }
            let dates = [];
            this.calendarCalculator.dates.forEach((date) => {
                if (date.month() + 1 != this.form.month) {
                    return;
                }
                dates.push({
                    date: date.format("YYYY-MM-DD"),
                    first_line_overlaps_date:
                        this.calendarCalculator.firstLineOverlapsDateNumber(
                            this.$refs.calendar.getEventsForDate(date)
                        )
                });
            });
            return dates;
        },
        onColorActiveChange(e, event) {
            event.color = window.Utils.rgbToHex(e);
            $(
                `.el-color-picker[data-event-uuid=${event._uuid}] .el-color-picker__trigger`
            ).click();
        },
        checkTimeValueBeforeThrowsError(event) {
            if (event.is_all_day) {
                return false;
            }
            return !event.time;
        },
        onEnterEventDescription(e, event) {
            let desc = event.description ? event.description : "";
            let start = desc.slice(0, this.descriptionInputCursor.start);
            let end = desc.slice(this.descriptionInputCursor.end, desc.length);
            event.description =
                start +
                window.App.state.config.settings.calendar.newline_char +
                end;
            Vue.nextTick(() => {
                e.target.setSelectionRange(
                    this.descriptionInputCursor.start + 1,
                    this.descriptionInputCursor.start + 1
                );
            });
        },
        saveDescriptionCursor(target) {
            this.descriptionInputCursor.start = target.selectionStart;
            this.descriptionInputCursor.end = target.selectionEnd;
        },
        trackTypingActivity() {
            if (
                this.$parent &&
                typeof this.$parent.trackTypingActivity === "function"
            ) {
                this.$parent.trackTypingActivity();
            }
        },
        onKeyUpDescription(e, event) {
            this.saveDescriptionCursor(e.target);
            this.trackTypingActivity();
            // Clear validation error when user starts typing
            const fieldName = "description-" + event._uuid;
            if (event.description && event.description.trim()) {
                this.clearValidationError(fieldName);
            }
        },
        onFocusDescription(e, event) {
            this.saveDescriptionCursor(e.target);
        },
        onClickDescription(e, event) {
            this.saveDescriptionCursor(e.target);
        },
        refreshCalendar() {
            if (this.$refs.calendar) {
                this.$refs.calendar.refreshCalendarDisplay({
                    caller: "Events.refreshCalendar"
                });
            }
        },
        clearValidationError(fieldName) {
            if (this.veeErrors.has(fieldName)) {
                this.veeErrors.remove(fieldName);
            }
        },
        onTimeChange(event) {
            const fieldName = "time-" + event._uuid;
            if (event.time || event.is_all_day) {
                this.clearValidationError(fieldName);
            }
        },
        onRepeatIntervalChange(event) {
            const fieldName = "repeat_interval-" + event._uuid;
            if (event.repeat_interval) {
                this.clearValidationError(fieldName);
            }
        },
        async validateBeforeSubmit() {
            this.veeErrors.clear();
            const isValid = await this.$validator.validate();
            return isValid;
        },
        onTimeInput(event) {
            console.log("[onTimeInput] called for", event._uuid, event.time);
            if (event.time && this.veeErrors.has("time-" + event._uuid)) {
                this.clearValidationError("time-" + event._uuid);
            }
        },
        onTimeBlur(event) {
            console.log("[onTimeBlur] called for", event._uuid);
            this.$validator.validate("time-" + event._uuid);
        }
    }
};
</script>

<style lang="scss" scoped>
.dialog-edit-date > .el-dialog {
    max-width: 800px;
}

.form-edit-events {
    .el-form-item__error {
        position: absolute;
    }
}
</style>
